import React from 'react';

import pageStyles from "../../containers/StewardAssetEditPage/StewardAssetEditPage.scss";

export default function SiteMapTab() {
  return (
    <div className={pageStyles["rec-area-tab"]}>
      <strong>There are currently no Site Maps available for this Recreation Area.</strong>
    </div>
  );
}
